import { type ListSlackIntegrationsObject } from '@air/api/types';
import { ConfirmationModal } from '@air/component-confirmation-modal';

import { useRemoveBoardSlackIntegration } from '~/swr-hooks/slack/useRemoveBoardSlackIntegration';

export type DeleteSlackIntegrationModalProps = {
  integration: ListSlackIntegrationsObject;
  boardId: string;
} & AirModalProps;

export const DeleteBoardSlackIntegrationModal = ({
  onClose,
  integration,
  boardId,
}: DeleteSlackIntegrationModalProps) => {
  const { removeBoardSlackIntegration } = useRemoveBoardSlackIntegration();

  // biome-ignore lint/plugin: this click handler is created for one modal instance and closes over this integration's ids
  const onClick = async () => {
    void removeBoardSlackIntegration({
      integrationId: integration.integrationId,
      receiverId: integration.receiverId,
      boardId,
      channelName: integration.channelName,
    });
    onClose();
  };

  const modalDescription = (
    <p className="ads:text-secondary text-14 text-gray-11">
      Are you sure you want to disconnect this Slack integration? Any other integrations you’ve created will remain
      active.
    </p>
  );

  return (
    <ConfirmationModal
      isOpen
      id="delete-slack-integration-modal"
      title="Disconnect Slack channel?"
      description={modalDescription}
      onDismiss={onClose}
      ctaPrimaryText="Disconnect"
      onConfirm={onClick}
      ctaSecondaryText="Cancel"
      isDangerous
    />
  );
};
